<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12" class="content_category mb-3 rounded-lg">
            <v-row class="pl-3">
              <v-col cols="12" class="content_category rounded-lg d-flex">
                <h3 class="mt-2">Banner</h3>
                <v-btn
                  class="ml-5 mb-5"
                  color="primary"
                  @click="addBanner()"
                >
                  Thêm
                </v-btn>
              </v-col>
              
              <v-col cols="6" class="content_category mb-3 rounded-lg" v-for="(item, index) in banners" :key="index">
                <form-link class="content_category mr-2 rounded-lg content_banner" :banner="item" @updateBanner="updateBanner" @removeBanner="removeBanner" :index="index"> </form-link>
              </v-col>
            </v-row>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg">
              <v-col class="mx-3">
                <v-row>
                  <v-row>
                    <h3 class="ml-9 mt-2">Top category</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addCategoryTop()"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-row>
                <v-col>
                  <v-divider></v-divider>
                  <div
                    class="content_property mt-5 rounded-lg"
                    v-for="(item, index) in topCategories"
                    :key="index"
                  >
                    <v-col>
                      <div style="display: flex; justify-content: flex-end">
                        <v-btn color="primary" @click="clearCategoryTop(index)">
                          Xóa
                        </v-btn>
                      </div>
                    </v-col>
                    <v-col>
                      <v-autocomplete
                        v-model="item.category_id"
                        background-color="#EDF2F7"
                        filled
                        item-value="id"
                        item-text="name"
                        :items="categories"
                        label="Topcategory"
                        placeholder="Chọn category"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-color-picker
                        height="350px"
                        width="400px"
                        v-model="item.color"
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-col>
                  </div>
                </v-col>
              </v-col>
            </v-col>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg">
              <v-col class="mx-3">
                <v-col>
                  <v-row>
                    <h3 class="ml-9 mt-2">Categories có hiển thị sản phẩm</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addCategory()"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(item, indexCategories) in categoryIds"
                    :key="indexCategories"
                  >
                    <v-row class="ma-0 pa-0">
                      <v-col cols="5" class="ma-0 pa-0 pr-1">
                        <v-autocomplete
                          v-model="item.category_id"
                          background-color="#EDF2F7"
                          filled
                          item-value="id"
                          item-text="name"
                          :items="categories"
                          label="Topcategory"
                          placeholder="Chọn category"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearCategory(indexCategories)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-col cols="12" class="text-center mt-3">
        <v-btn color="primary" width="180" @click="save()"> Lưu </v-btn>
      </v-col>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import {
  GET_LIST_CONFIG_FINISH,
  UPDATE_LIST_CONFIG_FINISH,
} from "@/store/modules/configs";
import FormLink from "@/views/Pages/config/util/form_link";
export default {
  components: {
    FormLink,
  },

  data() {
    return {
      topCategories: [],
      categoryIds: [],
      banners: [],
      banner: {
          photo_url: "",
          photo_url_mobile: "",
          type: null,
          link: {
            type: null,
            object_id: null,
            url: null,
          }
      },
      types: [
        {
          id: 1,
          text: "Link theo loại",
        },
        {
          id: 2,
          text: "Link theo URL",
        },
      ],
      image: {},
      src: "",

      src_banner_mobile: "",
      src_banner_desktop: "",
      category: {
        id: -1,
      },

      page: "Quản lý Finish",

      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Finish",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      categories: "categories",
      config_finish: "config_finish",
    }),
  },
  watch: {
    config_finish(val) {
      this.banners = val.banner ?? [];
      this.categoryIds = val.categories ?? [];
      this.topCategories = val.topCategories ?? [];
    },
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_CATEGORY}`);
    await this.$store.dispatch(`${GET_LIST_CONFIG_FINISH}`);
  },
  mounted() {},
  methods: {
    addCategoryTop() {
      this.topCategories.push({
        category_id: this.category.id,
        color: ""
      });
    },
    clearCategoryTop(i) {
      this.topCategories.splice(i, 1);
      this.$forceUpdate();
    },
    addCategory() {
      this.categoryIds.push({
        category_id: this.category.id,
      });
    },
    clearCategory(i) {
      this.categoryIds.splice(i, 1);
      this.$forceUpdate();
    },
    save() {
      let body = {
        banner: this.banners,
        categories: this.categoryIds,
        topCategories: this.topCategories,
      };
      if (body.banner.type == 1) {
        body.banner.link.url = null;
      }
      if (body.banner.type == 2) {
        body.banner.link.object_id = null;
        body.banner.link.type = null;
      }
      this.$store
        .dispatch(`${UPDATE_LIST_CONFIG_FINISH}`, body)
        .then((data) => {
          if (data.status === 1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            this.$store.dispatch(`${GET_LIST_CONFIG_FINISH}`);
          } else {
            alert(data.errors);
          }
        });
      // console.log("4/8/2022", this.check1);
    },
    addBanner() {
      this.banners.push({
        photo_url: this.banner.photo_url,
        photo_url_mobile: this.banner.photo_url_mobile,
        type: this.banner.type,
        link: this.banner.link,
      });
    },
    updateBanner(val) {
      this.banners[val.index] = val.banner
    },
    removeBanner(i) {
      this.banners.splice(i, 1);
      this.$forceUpdate();
    }
  },
};
</script>
<style lang="scss">
.content_property {
  padding: 15px;
  border-style: groove;
}
.content_banner {
  padding: 15px;
  border-style: groove;
}
.content_category1 {
  background: #ffffff !important;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
}
.production .ck-editor__main .ck-content {
  height: 140px;
}
.right {
  float: right;
}
</style>